@if (isPhoenix) {
  <amfam-phoenix-choose-account-wrapper />
} @else if (isHomesite) {
  <!-- TODO: The component is not refreshing when a payment is added.  -->
  <ds-hs-choose-account-wrapper
    (addCheckingAccountEvent)="addCheckingAccount()"
    (addCreditDebitEvent)="addCreditDebit()"
  />
} @else {
  @if (!simplifiedPaymentP2Enabled) {
    <div class="container">
      <h2 data-cy="accountSelectionHeading">{{ accountSelectionHeading }}</h2>
      <p data-cy="accountSelectionSubHeading">{{ accountSelectionSubHeading }}</p>
      <div class="flex justify-center">
        @if ((billAccountOptions$ | async).length) {
          <div class="accountContainer">
            <form [formGroup]="accountSelectionFormGroup">
              <amfam-simplified-payment-checkbox
                [controlName]="'option'"
                [parentFormGroup]="accountSelectionFormGroup"
                [billAccountOptions]="billAccountOptions$ | async"
                (checkBoxClickEvent)="handleCheckBoxInteraction()"
                (linkTextEvent)="linkTextEvent($event)"
                (updateAccountEvent)="updateAccountEvent($event)"
              ></amfam-simplified-payment-checkbox>
            </form>
          </div>
        }
      </div>
    </div>
  }

  @if (simplifiedPaymentP2Enabled) {
    <div class="simplified-container">
      <h2 data-cy="accountSelectionHeadingPTwo">{{ accountSelectionHeadingP2 }}</h2>

      <div class="flex justify-center">
        @if ((billAccountOptions$ | async).length) {
          <div class="account-container">
            <div class="flex payment">
              <form [formGroup]="accountSelectionFormGroup">
                <div class="payment-account">
                  <!-- Account and payment selection -->
                  <div class="flex subheading">
                    <div class="plusSign" data-cy="accountSelectionStepOne">{{ 1 }}</div>
                    <h3 data-cy="selectAccountSubHeading">{{ accountSelectionSubHeading }}</h3>
                  </div>
                  <div>
                    <amfam-simplified-payment-checkbox
                      [controlName]="'option'"
                      [parentFormGroup]="accountSelectionFormGroup"
                      [billAccountOptions]="billAccountOptions$ | async"
                      [hasMultiBillAccForRome]="hasMultiBillAccForRome"
                      [romeFeaturePill]="romeFeaturePill"
                      (checkBoxClickEvent)="handleCheckBoxInteraction()"
                      (linkTextEvent)="linkTextEvent($event)"
                      (updateAccountEvent)="updateAccountEvent($event)"
                    ></amfam-simplified-payment-checkbox>
                  </div>
                </div>
              </form>
              <form [formGroup]="paymentMethodAndDateFormGroup">
                <!-- Payment method -->
                <div class="payment-method">
                  <div class="flex payment-method-subheading">
                    <div class="plusSign" data-cy="paymentMethodSelectionStepTwo">{{ 2 }}</div>
                    <h3 data-cy="selectPaymentMethodHeader">Select a payment method</h3>
                  </div>
                  <p data-cy="selectPaymentMethodText">Choose, add or edit a payment method.</p>
                  <ds-payment-method
                    [formGroup]="paymentMethodAndDateFormGroup"
                    [paymentMethodOptions]="paymentMethodOptions"
                    [control]="'paymentMethod'"
                    [paymentMethodError]="paymentMethodError"
                    [authorizedToAddPaymentMethod]="authorizedToAddPaymentMethod$ | async"
                    [authorizedToEditPaymentMethod]="authorizedToEditPaymentMethod$ | async"
                    (editPaymentMethodEvent)="editPaymentMethod($event)"
                    (addCheckingAccountEvent)="addCheckingAccount()"
                    (addSavingsAccountEvent)="addSavingsAccount()"
                    (addCreditDebitEvent)="addCreditDebit()"
                  ></ds-payment-method>
                </div>
                <!-- Payment date -->
                <div class="payment-date">
                  @if ((datePickerEligibleAndTotal$ | async).disableCalender) {
                    <div class="flex payment-date-box" data-cy="datePicker">
                      <div class="payment-date-left">
                        <div class="flex subheading">
                          <div class="plusSign" data-cy="dateSelectionStepThree">{{ 3 }}</div>
                          <h3 data-cy="dateSelectionHeader">Payment will be made today</h3>
                        </div>
                        <div class="flex">
                          <p data-cy="selectPaymentDateText">Payment initiated on:</p>
                          <p class="bold" data-cy="selectPaymentDateTextTwo">{{ todayDate }}</p>
                        </div>
                      </div>
                      <div class="payment-date-right" data-cy="cannotEditDate">
                        <p class="bold" data-cy="cannotEditDateTextOne">
                          Why can't I edit the date?
                        </p>
                        <p data-cy="cannotEditDateTextTwo">There can be a few reasons:</p>
                        <ul>
                          <li data-cy="cannotEditDateTextThree">Your payment is due today</li>
                          <li data-cy="cannotEditDateTextFour">You're paying a past due bill</li>
                          <li data-cy="cannotEditDateTextFive">
                            You're paying towards your account balance
                          </li>
                        </ul>
                        <p data-cy="cannotEditDateTextSix">
                          To edit your payment date, scroll up and deselect any ineligible bills.
                        </p>
                      </div>
                    </div>
                  } @else {
                    <div class="flex">
                      <div class="payment-date-left">
                        <div class="flex subheading">
                          <div class="plusSign" data-cy="stepThreeNonPastDue">{{ 3 }}</div>
                          <h3 data-cy="stepThreeNonPastDueText">Select a payment date</h3>
                        </div>
                        <ds-date-picker
                          [formGroup]="paymentMethodAndDateFormGroup"
                          [matDatePickerOptions]="matDatePickerOptions"
                          [dateClass]="dateClass"
                        ></ds-date-picker>
                      </div>
                    </div>
                  }
                </div>
              </form>
            </div>
          </div>
        }
      </div>
    </div>
  }

  @if ((billAccountOptions$ | async).length) {
    <div class="sticky-container">
      <call-to-action
        [secondaryButtonName]="'Cancel'"
        [disablePrimaryButton]="
          !simplifiedPaymentP2Enabled
            ? accountSelectionFormGroup.invalid
            : accountSelectionFormGroup.invalid || paymentMethodAndDateFormGroup.invalid
        "
        [primaryButtonName]="
          !simplifiedPaymentP2Enabled
            ? 'CONTINUE'
            : 'Review Payment ' + ((datePickerEligibleAndTotal$ | async).sum | currencyUSD)
        "
        (primaryEvent)="submit()"
        (secondaryEvent)="cancel()"
      ></call-to-action>
    </div>
  }

  <ds-alert-modal
    [config]="silentRegistrationAllFailedError"
    (primaryEvent)="closeSilentRegistrationErrorModal()"
  >
  </ds-alert-modal>
  <ds-alert-modal
    [config]="silentRegistrationPartialError"
    (primaryEvent)="continueWithSuccessfulRegistration()"
    (secondaryEvent)="closeSilentRegistrationErrorModal()"
  >
  </ds-alert-modal>

  <ds-alert-modal
    [config]="cancelModalConfig"
    (primaryEvent)="leave()"
    (tertiaryEvent)="stay()"
  ></ds-alert-modal>

  <ds-rome-bill-payment-faq-modal [id]="romeBannerPaymentModalId"></ds-rome-bill-payment-faq-modal>
}
<ds-payment-method-modal
  [paymentMethodAddEditConfig]="paymentMethodAddEditConfig$ | async"
  (paymentMethodAddEditCompleteEvent)="paymentMethodAddEditComplete($event)"
>
</ds-payment-method-modal>
